import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPlatformReviews } from "../../../../actionCreator/reputationManagerActionCreator";

export const useReviews = () => {
  const dispatch = useDispatch();
  const reviews = useSelector((state) => state.ReputationMangerReducer.reviews);
  const loading = useSelector((state) => state.ReputationMangerReducer.loading);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const getReviews = () => {
      const allParams = {};
      for (const [key, value] of searchParams.entries()) {
        allParams[key] = value;
      }
      dispatch(
        getPlatformReviews({
          ...allParams,
          page: allParams?.page ? allParams?.page - 1 : 0,
        })
      );
    };
    getReviews();
  }, [dispatch, searchParams]);

  return { reviews, loading };
};
